import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'components/ui/select';
import { Globe, Type } from 'lucide-react';

const TEXT_SIZES = {
  normal: { label: 'Normal', scale: '100%' },
  large: { label: 'Large', scale: '112.5%' },
  xl: { label: 'Extra Large', scale: '125%' }
};

export default function AccessibilitySettings() {
  const { t, i18n } = useTranslation();
  const [textSize, setTextSize] = useState(() => localStorage.getItem('elderlink_text_size') || 'normal');

  useEffect(() => {
    document.documentElement.style.fontSize = TEXT_SIZES[textSize]?.scale || '100%';
    localStorage.setItem('elderlink_text_size', textSize);
  }, [textSize]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="flex items-center gap-2" data-testid="accessibility-controls">
      {/* Language Switcher */}
      <Select value={i18n.language?.substring(0, 2) || 'en'} onValueChange={changeLanguage}>
        <SelectTrigger className="w-24 sm:w-32 h-8 text-xs" data-testid="language-switcher">
          <Globe className="w-3 h-3 shrink-0" />
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="en">English</SelectItem>
          <SelectItem value="es">Espanol</SelectItem>
        </SelectContent>
      </Select>

      {/* Text Size - hidden on small screens */}
      <div className="hidden sm:flex items-center border rounded-md h-8" data-testid="text-size-controls">
        {Object.entries(TEXT_SIZES).map(([key, { label }]) => (
          <button
            key={key}
            onClick={() => setTextSize(key)}
            className={`px-2 h-full text-xs transition-colors ${textSize === key ? 'bg-teal-500 text-white' : 'text-slate-600 hover:bg-slate-100'} ${key === 'normal' ? 'rounded-l-md' : key === 'xl' ? 'rounded-r-md' : ''}`}
            data-testid={`text-size-${key}`}
            aria-label={`Set text size to ${label}`}
          >
            <Type className={`${key === 'normal' ? 'w-3 h-3' : key === 'large' ? 'w-3.5 h-3.5' : 'w-4 h-4'}`} />
          </button>
        ))}
      </div>
    </div>
  );
}
